import { pxToRemString } from '@ms/yammer-web-core-ui/dist/util/styles/fonts';
import { IStyle, memoizeFunction, mergeStyleSets } from '@ms/yammer-web-core-ui/dist/util/styling';

const root = {
  wordWrap: 'normal',
  textTransform: 'none',
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px',
  display: 'block',
};

const focused = {
  position: 'fixed',
  left: '0px',
  top: '50px',
  width: 'auto',
  height: 'auto',
  margin: '10px',
  padding: '6px 10px',
  textAlign: 'left',
  backgroundColor: '#ffe7b8',
  border: 'solid 1px #ffc56c',
  borderRadius: '2px',
  fontSize: pxToRemString(12),
  lineHeight: pxToRemString(16),
  clip: 'auto',
  zIndex: 1,
};

/**
 * Casting as IStyle until IRawStyleBase includeds 'clip' attribute.
 */
export const getClassNames = memoizeFunction(() =>
  mergeStyleSets({
    root: root as IStyle,
    focused: focused as IStyle,
  })
);
